<template>
  <el-select ref="driver" v-model="selected" clearable filterable collapse-tags multiple v-loading="loading"
    :disabled="disabled ? true : false" :placeholder="$t('selecione-uma-opcao')" @change="update()">
    <el-option key="" label="Todos" value=""></el-option>
    <el-option v-for="row of drivers" :key="row.id" :label="row.name" :value="row.id"></el-option>
  </el-select>
</template>

<script>
import { DriversService } from "@/services/customers/drivers.services";
export default {
  name: "UserDriversList",
  data: function () {
    return {
      drivers: [],
      selected: "",
      loading: false,
    };
  },
  props: {
    current: String,
    disabled: Boolean,
  },
  methods: {
    fetchDrivers() {
      const vm = this;
      vm.loading = true;
      DriversService.list()
        .then((response) => {
          vm.drivers = response.sort((a, b) => a.name.localeCompare(b.name));
        })
        .catch((error) => {
          vm.$notify.error({
            title: i18n.tc("erro"),
            message: error,
          });
        })
        .finally(() => (vm.loading = false));
    },
    update() {
      const vm = this;
      vm.$emit("input", vm.selected);
      vm.$emit("selected", vm.selected);
    },
  },
  mounted() {
    const vm = this;
    vm.fetchDrivers();
  },
};
</script>